import React from 'react'

const About = () => {
  return (
    <div name="about" className='w-full h-screen bg-gradient-to-b from-gray-800 to-black text-white'>
      <div className='max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full'>
        <div className='pb-8'>
            <p className='text-4xl font-bold inline border-b-4 border-gray-500'>
                About
            </p>
        </div>
        <p className='text-xl mt-20'>
            
        Priya, a tech enthusiast currently pursuing MCA, stands at the intersection of innovation and creativity. Proficient in HTML, CSS, JavaScript, React, Tailwind CSS, Material UI, Java, and well-versed in OOP, data structures, and algorithms, I thrive on the challenges of the digital landscape.
<br/>
<br/>
My competitive programming skills showcase my dedication to continuous learning, while my artistic hobbies in photography and sketching demonstrate a balanced blend of logic and creativity. Adaptable and quick to embrace change, I effortlessly integrate into new environments, fostering connections with diverse individuals.
        </p>
        <br/>
        <p className='text-xl'>
        I bring a unique combination of technical expertise and a creative mindset to any project or team. Beyond the lines of code, I am a storyteller, using pixels and strokes to convey narratives that captivate and inspire. Let's embark on a journey of innovation and collaboration, where every challenge becomes an opportunity to shine.
        <br/>
<br/>
Let's innovate, learn, and create together:)






        </p>
      </div>
    </div>
  );
};

export default About
